var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "empty_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 151,
    height: 151,
    viewBox: "0 0 151 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_632",
    "data-name": "Rectangle 632",
    width: 151,
    height: 151,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M54,98.36H82.361a4.942,4.942,0,0,0,2.589-.765l11.767-7.884a4.942,4.942,0,0,1,2.589-.765h36.241V74.827a4.707,4.707,0,0,0-4.707-4.707H90.068a4.765,4.765,0,0,1-2.824-.941L70.889,56.941A4.765,4.765,0,0,0,68.065,56H36.707A4.707,4.707,0,0,0,32,60.707v84.719L49.65,101.3A4.648,4.648,0,0,1,54,98.36Z",
    transform: "translate(-13.174 -23.053)",
    fill: "#8181a5",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M32,145.426V60.707A4.707,4.707,0,0,1,36.707,56H68.065a4.765,4.765,0,0,1,2.824.941L87.244,69.179a4.766,4.766,0,0,0,2.824.941h40.771a4.707,4.707,0,0,1,4.707,4.707v14.12",
    transform: "translate(-13.174 -23.053)",
    fill: "none",
    stroke: "#464545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M32,168.48l17.65-44.125A4.648,4.648,0,0,1,54,121.413H82.361a4.942,4.942,0,0,0,2.589-.765l11.767-7.884A4.942,4.942,0,0,1,99.3,112h48.537a4.707,4.707,0,0,1,4.471,6.177l-16.767,50.3Z",
    transform: "translate(-13.174 -46.105)",
    fill: "none",
    stroke: "#464545",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyIcon);
export default __webpack_public_path__ + "static/media/empty_icon.ea86f3e6f74671065b99cc7f2b2d2c6c.svg";
export { ForwardRef as ReactComponent };